import { Layout, USLogo } from '@tracsis/library/src';
import '@tracsis/library/src/global-styles/app.css';
import React from 'react';

import {
	FOOTER_NAV_1,
	FOOTER_NAV_2,
	FOOTER_NAV_3,
	FOOTER_NAV_4,
	FOOTER_NAV_5,
	NAVIGATION,
	SOCIAL,
	SUB_COMPANIES,
	SUB_NAVIGATION,
} from '../../constants/Navigation';

const Page = ({ children }: { children: React.ReactNode }) => {
	return (
		<Layout
			siteName="Tracsis US"
			logo={<USLogo />}
			navigation={NAVIGATION}
			subNavigation={SUB_NAVIGATION}
			mobileSubNavigation={SUB_COMPANIES}
			social={SOCIAL}
			footer="altfooter"
			footerNav1={FOOTER_NAV_1}
			footerNav2={FOOTER_NAV_2}
			footerNav3={FOOTER_NAV_3}
			footerNav4={FOOTER_NAV_4}
			footerNav5={FOOTER_NAV_5}
			iso={[
				{
					link: 'https://tracsis.com/documents/Certificate Tracsis PLC 14001 2023-2026 12655.pdf',
					text: '12655-EMS-001 ISO14001:2015',
				},
				{
					link: '/iso/Certificate Tracsis Railcomm 2023-2025.pdf',
					text: '11752-ISMS-010 ISO27001:2013',
				},
			]}>
			{children}
		</Layout>
	);
};

export default Page;
